export const userRolePerKey = {
  admin: 'Admin',
  approver: 'Approver',
  'content-manager': 'Content Manager',
  'cs-admin': 'CS Admin',
  'super-admin': 'Super Admin',
  user: 'User',
  viewer: 'Viewer',
}
